"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.SubTitle = exports.NonHeadingTitle = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _lodash = require("lodash");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_tu0wd5d7s() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductTitle.js";
  var hash = "34610714256abd145c0ef93197ab4d5d1e2d73fc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductTitle.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 6
        }
      },
      "2": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 43
        }
      },
      "3": {
        start: {
          line: 24,
          column: 24
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "4": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 29,
          column: 8
        }
      },
      "5": {
        start: {
          line: 35,
          column: 28
        },
        end: {
          line: 35,
          column: 46
        }
      },
      "6": {
        start: {
          line: 54,
          column: 17
        },
        end: {
          line: 77,
          column: 2
        }
      },
      "7": {
        start: {
          line: 55,
          column: 22
        },
        end: {
          line: 55,
          column: 90
        }
      },
      "8": {
        start: {
          line: 79,
          column: 0
        },
        end: {
          line: 82,
          column: 2
        }
      },
      "9": {
        start: {
          line: 84,
          column: 0
        },
        end: {
          line: 86,
          column: 2
        }
      },
      "10": {
        start: {
          line: 88,
          column: 0
        },
        end: {
          line: 91,
          column: 2
        }
      },
      "11": {
        start: {
          line: 93,
          column: 0
        },
        end: {
          line: 95,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 11,
            column: 14
          }
        },
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 6
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 15
          },
          end: {
            line: 17,
            column: 16
          }
        },
        loc: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 43
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 15
          },
          end: {
            line: 26,
            column: 16
          }
        },
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 29,
            column: 8
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 20
          }
        },
        loc: {
          start: {
            line: 35,
            column: 28
          },
          end: {
            line: 35,
            column: 46
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 13
          },
          end: {
            line: 55,
            column: 14
          }
        },
        loc: {
          start: {
            line: 55,
            column: 22
          },
          end: {
            line: 55,
            column: 90
          }
        },
        line: 55
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "34610714256abd145c0ef93197ab4d5d1e2d73fc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_tu0wd5d7s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_tu0wd5d7s();
var Title = exports.Title = (cov_tu0wd5d7s().s[0]++, _styledComponents.default.h3.attrs({
  className: function className(props) {
    cov_tu0wd5d7s().f[0]++;
    cov_tu0wd5d7s().s[1]++;
    return (0, _utils.classNames)('stx-ProductCardTitle', (0, _defineProperty2.default)({}, "stx-ProductCardTitle-".concat(props.productId), props.productId));
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  font-size: ", ";\n  white-space: normal;\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n"])), function (props) {
  cov_tu0wd5d7s().f[1]++;
  cov_tu0wd5d7s().s[2]++;
  return props.titleFontSize;
}));
var NonHeadingTitle = exports.NonHeadingTitle = (cov_tu0wd5d7s().s[3]++, (0, _utils.withThemedStyles)(_styledComponents.default.p.attrs({
  className: function className(props) {
    cov_tu0wd5d7s().f[2]++;
    cov_tu0wd5d7s().s[4]++;
    return (0, _utils.classNames)('stx-ProductCardTitle', (0, _defineProperty2.default)({}, "stx-ProductCardTitle-".concat(props.productId), props.productId));
  },
  'aria-hidden': true
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      font-size: ", ";\n      white-space: normal;\n      font-weight: 700;\n      margin: 0;\n      padding: 0;\n    "])), function (props) {
  cov_tu0wd5d7s().f[3]++;
  cov_tu0wd5d7s().s[5]++;
  return props.textFontSize;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      padding: 0;\n      margin: 24px 0;\n      white-space: pre-wrap;\n      font-weight: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      color: var(--productNameTextColor, #000);\n    "])), (0, _lodash.get)(_themeMapper.evolutionTheme, 'fontWeight.semibold', 600), (0, _lodash.get)(_themeMapper.evolutionTheme, 'typography.body1.fontSize', '18px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'typography.body1.lineHeight', '26px')))));
var SubTitle = exports.SubTitle = (cov_tu0wd5d7s().s[6]++, (0, _utils.withThemedStyles)(_styledComponents.default.h4.attrs({
  className: function className(props) {
    cov_tu0wd5d7s().f[4]++;
    cov_tu0wd5d7s().s[7]++;
    return "stx-ProductCardSubtitle stx-ProductCardSubtitle-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    display: block;\n    font-size: ", ";\n    color: ", ";\n    font-weight: bold;\n    text-transform: uppercase;\n    white-space: normal;\n    margin: 0;\n    padding: 0;\n  "])), _stylingConstants.default.font.sizeXs, _stylingConstants.default.color.baseSubTitle)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    display: block;\n    font-size: ", ";\n    color: var(--subtleTextColor, #4a4458);\n    font-weight: ", ";\n    text-transform: uppercase;\n    white-space: normal;\n    margin: 0;\n    padding: 0;\n  "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.fontWeight.normal))));
cov_tu0wd5d7s().s[8]++;
Title.propTypes = {
  /* The product title font-size to display */
  titleFontSize: _propTypes.default.string
};
cov_tu0wd5d7s().s[9]++;
Title.defaultProps = {
  titleFontSize: _stylingConstants.default.font.sizeL
};
cov_tu0wd5d7s().s[10]++;
NonHeadingTitle.propTypes = {
  /* The product title font-size to display */
  textFontSize: _propTypes.default.string
};
cov_tu0wd5d7s().s[11]++;
NonHeadingTitle.defaultProps = {
  textFontSize: _stylingConstants.default.font.sizeL
};